/* eslint-disable import/prefer-default-export */
import { ExchangeColor } from '@api/returns/types'
import Translations from '@helpers/translations'
import { returnsClickEvent } from '@components/returns/helpers'
import { RETURN_REASON_CODES } from '@components/returns/consts'
import { Button } from '@components/ui/Button'
import SwatchColor from '@components/ui/SwatchColor'
import { Values } from '@components/returns/types'
import ButtonsWrapper from '../../../shared/ButtonsWrapper'
import FormWrapper from '../../../shared/FormWrapper'
import colorStepStyles from './colorStepStyles.module.scss'
import ButtonMinimal from '@components/ui/Button/ButtonMinimal'

export type ColorStepProps = {
  values: Values
  exchangeColors: ExchangeColor[]
  setSelection: (selection: { color: ExchangeColor | undefined }) => void
  onUpdate: (step: string) => void
  isLastStep: boolean
}

export function ColorStep({
  values,
  exchangeColors,
  setSelection,
  onUpdate,
  isLastStep
}: ColorStepProps) {
  const isReasonColor = values.reason === RETURN_REASON_CODES.COLOR
  const isColorExchangeValid = values.color

  const titleText = isReasonColor
    ? 'Choose a new colour'
    : 'Do you want to change colour?'

  const clearSelectionText = 'Clear selection'

  const buttonText: string = (() => {
    if (isLastStep && isColorExchangeValid) {
      return Translations.localise('pages.returns.done')
    }

    if (isReasonColor) {
      return 'Next'
    }

    return 'Keep this colour'
  })()

  const handleUpdate = (step: string) => {
    returnsClickEvent({
      label: buttonText
    })
    onUpdate(step)
  }

  const handleClear = () => {
    returnsClickEvent({
      label: clearSelectionText
    })
    setSelection({ color: undefined })
  }

  return (
    <>
      <FormWrapper title={titleText}>
        <div className={colorStepStyles.ColorStep__colorsContainer}>
          <div className={colorStepStyles.ColorStep__colorsList}>
            {exchangeColors?.map(productColorData => {
              const isSelected =
                values.color?.product_id === productColorData.product_id
              return (
                <button
                  type="button"
                  onClick={() => setSelection({ color: productColorData })}
                  key={productColorData.title}
                >
                  <SwatchColor
                    colorName={productColorData.title}
                    active={isSelected}
                    primary={productColorData.color?.primary ?? ''}
                    secondary={productColorData.color?.secondary ?? null}
                    image={productColorData.color?.image ?? null}
                  />
                </button>
              )
            })}
          </div>
          <div className={colorStepStyles.ColorStep__colorFooter}>
            {values.color && (
              <>
                <p className={colorStepStyles.ColorStep__colorTitle}>
                  {values.color?.title}
                </p>
                <ButtonMinimal
                  onClick={handleClear}
                  underlined={true}
                  textSize="large"
                >
                  {clearSelectionText}
                </ButtonMinimal>
              </>
            )}
          </div>
        </div>
      </FormWrapper>
      <ButtonsWrapper onUpdate={handleUpdate}>
        <Button
          classes={
            buttonText === 'Keep this colour'
              ? colorStepStyles.ColorStep__button
              : ''
          }
          disabled={isReasonColor && !isColorExchangeValid}
          variant="primary"
          fullWidth="always"
          onClick={() => handleUpdate(isLastStep ? 'done' : 'next')}
        >
          {buttonText}
        </Button>
      </ButtonsWrapper>
    </>
  )
}
